import type { TStatusPillVariant } from '@mopla/ui';

import { TMyTicketStatus } from './types';

/** Chip variant per ticket status. */
const STATUS_VARIANT: Record<TMyTicketStatus, TStatusPillVariant> = {
	active: 'success',
	preorder: 'info',
	invalid: 'error',
	expired: 'info',
	cancelled: 'info',
};

/**
 * Chip variant for `status`, shared by the Tickets tab cards, the Ticket
 * Detail screen and the Activities feed so the same ticket gets the same
 * colour everywhere.
 *
 * `status` is taken separately from the ticket because the detail screen
 * overrides the BE status once `validUntil` has passed.
 */
export const getMyTicketStatusVariant = (
	status: TMyTicketStatus
): TStatusPillVariant => STATUS_VARIANT[status];
